import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["accept"]
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_3 = { class: "text-center text-white w-100" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "flex-fill",
  style: {"padding-left":".7em !important"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["href"]

import {computed, getCurrentInstance, ref} from 'vue';
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatApiResult from "~/chat/ts/service/request/ChatApiResult";
import ObjectHelper from "~/ts/library/ObjectHelper";
import ChatModal from "~/chat/vue/widget/ChatModal.vue";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import Dictionary from "~/ts/library/Dictionary";
import ChatLightbox from "~/chat/vue/misc/ChatLightbox.vue";
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";
import {IChatUpload} from "~/chat/vue/widget/form/IChatUpload";
import {__} from "~/ts/library/Translate";
import ConsoleWrapper from "~/ts/library/Console";
import {ChatEventManagerInstance} from "~/chat/ts/ChatEventManager";
import {OPEN_UPLOAD_DIALOG_EVENT} from "~/chat/ts/service/api/methods/OpenUploadDialog";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";


const __default__ = {
    name: "ChatUpload"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    id: {},
    accept: {},
    showAcceptFiles: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["new-files"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let model = _useModel<string[]>(__props, "modelValue");

let input = ref<HTMLInputElement>();

let uploadStarted = ref(false);
let uploadPercent = ref(0);
let files = ref<Dictionary<IChatUploadFile>>({});
let lightboxVisible = ref(false);
let lightboxSrc = ref<string>();
let modalMessageVisible = ref(false);
let modalMessage = ref<string>();

function openUploadDialog() {
    input.value.click();
}

let acceptString = computed(() => {
    if (props.accept) {
        let result: string[] = [];
        if (props.accept) {
            result = props.accept.split(",")
                .map(item => item.trim())
                .filter(item => item.length > 0)
                .map(item => `.${item}`);
        }
        return result.length > 0 ? result.join(",") : undefined;
    }
    let extensions = ConfigStore.siteParams.value.params.allowedFileExtensions;
    return extensions && extensions.length ? "." + extensions.join(",.") : null;
});

function openLightbox(file: string) {
    lightboxSrc.value = file;
    lightboxVisible.value = true;
}

function removeFile(index: number) {
    if (model.value && model.value[index] != null) {
        let value = [...model.value];
        value.splice(index, 1);
        emitInput(value);
    }
}

function emitInput(value: string[]) {
    model.value = value.length ? value : null;
}

function getFileName(file: string, index: number): string {
    return files.value[file] ? files.value[file].filename : __('FILE_N', (index + 1).toString());
}

function isImage(file: string) {
    return !!files.value[file]?.isImage;
}

function showModalMessage(message: string) {
    modalMessage.value = message;
    modalMessageVisible.value = true;
}

function newFilesList(newFiles: FileList | File[], convertTo?: string) {
    if (newFiles.length) {
        let size = 0;
        const MAX_SIZE = 52428800;
        for (let i = 0; i < newFiles.length; i++) {
            let file = newFiles[i];
            size += file.size;
            if (size > MAX_SIZE) {
                showModalMessage(__("UPLOAD_FILE_SIZE_ERROR", Math.ceil(MAX_SIZE / 1024 / 1024)));
                input.value.value = '';
                return;
            }
        }


        uploadStarted.value = true;
        uploadPercent.value = 0;

        let xhr = new XMLHttpRequest();

        // отслеживаем процесс загрузки
        xhr.upload.onprogress = (event) => {
            uploadPercent.value = parseInt((event.loaded / event.total) * 100 as any);
        };

        // Ждём завершения: неважно, успешного или нет
        xhr.onloadend = () => {
            if (xhr.status == 200) {
                try {
                    let json = JSON.parse(xhr.responseText);
                    let result = new ChatApiResult(json);
                    if (result.isSuccess()) {
                        let filesInResult: {
                            code: number,
                            descr: string,
                            data: IChatUploadFile
                        }[] = result.getData("results");
                        if (filesInResult) {
                            let value = model.value ? ObjectHelper.jsonClone(model.value) : [];
                            let changed = false;
                            let newFiles = [];
                            for (let result of filesInResult) {
                                if (result.code == 1) {
                                    let file = result.data;
                                    newFiles.push(file);
                                    value.push(file.url);
                                    files.value[file.url] = file;
                                    changed = true;
                                } else {
                                    showModalMessage(__("UPLOAD_FILE_ERROR") + ": " + result.descr);
                                }
                            }
                            if (changed) {
                                emits("new-files", newFiles);
                                emitInput(value);
                            }
                        }
                    } else {
                        showModalMessage(result.getDescr());
                    }
                } catch (e) {
                    showModalMessage(__("UPLOAD_FILE_ERROR"));
                    ConsoleWrapper.log("Ошибка", e);
                }
            } else {
                showModalMessage(__("UPLOAD_FILE_ERROR"));
                ConsoleWrapper.log("Ошибка " + xhr.status);
            }
            uploadStarted.value = false;
        };

        let url = `${ConfigStore.apiHost.value}/json/anonymous/cors/upload?orgId=${ConfigStore.orgId.value}&siteId=${ConfigStore.siteId.value}&tag=onlineChatWidget`;
        if (convertTo) {
            url += `&convert=${convertTo}`;
        }
        xhr.open("POST", url);
        let formData = new FormData();
        for (let i = 0; i < newFiles.length; i++) {
            let file = newFiles[i];
            formData.append("file[]", file, file.name);
        }
        xhr.send(formData);
    }
}

let instance = getCurrentInstance().proxy;

function onChange(e: Event) {
    let files = (e.target as HTMLInputElement).files;
    if (acceptString.value) {
        let accept = acceptString.value.toLowerCase().split(",");

        if (accept.length > 0) {
            for (let i = 0; i < files.length; i++) {
                let name = files[i].name.split('.');
                let extension = name[name.length - 1].toLowerCase();
                if (!accept.includes(`.${extension}`)) {
                    input.value.value = '';
                    (new ChatApiResult({
                        code: 0,
                        descr: __('FILE_UPLOAD_EXTENSION', accept.join(', '))
                    })).showMessage(instance);
                    return;
                }
            }
        }
    }

    newFilesList(files);
}

addDisposableEvent(
    ChatEventManagerInstance.addEventListener(OPEN_UPLOAD_DIALOG_EVENT, (id: string) => {
        if (id === props.id) {
            openUploadDialog();
        }
    })
);

__expose<IChatUpload>({
    newFilesList
});


return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      onClick: openUploadDialog,
      onTouchup: openUploadDialog,
      class: _normalizeClass({disabled: _unref(uploadStarted)})
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 34),
    _createElementVNode("input", {
      ref_key: "input",
      ref: input,
      multiple: "",
      type: "file",
      class: "d-none",
      onChange: onChange,
      accept: _unref(acceptString)
    }, null, 40, _hoisted_1),
    (_ctx.showAcceptFiles && _unref(acceptString) && _unref(acceptString).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(__)('FILE_TYPES')) + ": " + _toDisplayString(_unref(acceptString).split(",").join(", ")), 1))
      : _createCommentVNode("", true),
    _createVNode(ChatModal, { visible: _unref(uploadStarted) }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(uploadPercent)) + "% ", 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    (__props.modelValue && __props.modelValue.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model), (file, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "mt-3 d-flex"
            }, [
              _createElementVNode("a", null, [
                _withDirectives(_createVNode(SvgIcon, {
                  "icon-name": "times",
                  "icon-style": "light"
                }, null, 512), [
                  [_directive_on_native, () => removeFile(index), "click"]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (isImage(file))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: ($event: any) => (openLightbox(file))
                    }, [
                      _createElementVNode("img", {
                        src: file,
                        class: "img-preview"
                      }, null, 8, _hoisted_7)
                    ], 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: file,
                      target: "_blank"
                    }, _toDisplayString(getFileName(file, index)), 9, _hoisted_8))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(ChatLightbox, {
      visible: _unref(lightboxVisible),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lightboxVisible) ? (lightboxVisible).value = $event : lightboxVisible = $event)),
      src: _unref(lightboxSrc)
    }, null, 8, ["visible", "src"]),
    _createVNode(ChatModalMessage, {
      visible: _unref(modalMessageVisible),
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(modalMessageVisible) ? (modalMessageVisible).value = $event : modalMessageVisible = $event))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(modalMessage)), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})